// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intent-verification-list {
  padding-top: 15px;
}

.pathlookup-checks__container {
  padding-top: var(--base-sizes-4);
  padding-bottom: var(--base-sizes-2);
  padding-right: var(--base-sizes-3);
  padding-left: var(--base-sizes-4);
  display: flex;
}

.pathlookup-checks__container:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.pathlookup-checks__badge {
  text-transform: uppercase;
  margin-right: var(--base-sizes-2);
  flex-direction: column;
  align-items: center;
  display: flex;
}

.pathlookup-checks__badge--pass {
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
  background-color: var(--severity-color-0);
}

.pathlookup-checks__badge--fail {
  background-color: var(--severity-color-30);
}

.pathlookup-checks__label {
  padding-bottom: var(--base-sizes-1);
}

.pathlookup-checks__label--main {
  font-size: .875rem;
  line-height: 1.25rem;
  font-weight: var(--base-font-weight-semibold);
}

.pathlookup-checks__label--minor {
  font-size: .75rem;
  line-height: 1rem;
  font-weight: var(--base-font-weight-bold);
}

.pathlookup-checks__data {
  font-size: .75rem;
  line-height: 1rem;
}

.pathlookup-checks__data--error {
  color: #de392c;
}

.severity-counts-list-item--intents {
  border-left: 3px solid #0000;
  padding-right: 30px;
  font-size: 13px;
}

.severity-counts-list-item--collabsible-label {
  font-weight: var(--base-font-weight-bold);
}

.severity-counts-list-item--collabsible-content {
  padding-left: var(--base-sizes-12);
}

.accordion__row--collapsed .severity-counts-list-item--intents-selected-within, .severity-counts-list-item--intents-selected {
  background: var(--lightgray-d);
  border-left: 3px solid #4f81bd;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphSidePanel/IntentVerification/styles.css","webpack://./services/frontend/app/components/Graph/GraphSidePanel/IntentVerification/styles.css"],"names":[],"mappings":"AADA;ECEE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC","sourcesContent":[".intent-verification-list {\n  padding-top: 15px;\n}\n\n.pathlookup-checks__container {\n  display: flex;\n  padding-top: var(--base-sizes-4);\n  padding-bottom: var(--base-sizes-2);\n  padding-right: var(--base-sizes-3);\n  padding-left: var(--base-sizes-4);\n}\n\n.pathlookup-checks__container:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(229 231 235 / var(--tw-bg-opacity));\n}\n\n.pathlookup-checks__badge {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-transform: uppercase;\n  margin-right: var(--base-sizes-2);\n}\n\n.pathlookup-checks__badge--pass {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n\n  background-color: var(--severity-color-0);\n}\n\n.pathlookup-checks__badge--fail {\n  background-color: var(--severity-color-30);\n}\n\n.pathlookup-checks__label {\n  padding-bottom: var(--base-sizes-1);\n}\n\n.pathlookup-checks__label--main {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: var(--base-font-weight-semibold);\n}\n\n.pathlookup-checks__label--minor {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: var(--base-font-weight-bold);\n}\n\n.pathlookup-checks__data {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.pathlookup-checks__data--error {\n  color: #de392c;\n}\n\n.severity-counts-list-item--intents {\n  border-left: 3px solid transparent;\n  padding-right: 30px;\n  font-size: 13px;\n}\n\n.severity-counts-list-item--collabsible-label {\n  font-weight: var(--base-font-weight-bold);\n}\n\n.severity-counts-list-item--collabsible-content {\n  padding-left: var(--base-sizes-12);\n}\n\n.accordion__row--collapsed .severity-counts-list-item--intents-selected-within,\n.severity-counts-list-item--intents-selected {\n  background: var(--lightgray-d);\n  border-left: 3px solid #4F81BD;\n}\n",".intent-verification-list {\n  padding-top: 15px;\n}\n\n.pathlookup-checks__container {\n  padding-top: var(--base-sizes-4);\n  padding-bottom: var(--base-sizes-2);\n  padding-right: var(--base-sizes-3);\n  padding-left: var(--base-sizes-4);\n  display: flex;\n}\n\n.pathlookup-checks__container:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(229 231 235 / var(--tw-bg-opacity));\n}\n\n.pathlookup-checks__badge {\n  text-transform: uppercase;\n  margin-right: var(--base-sizes-2);\n  flex-direction: column;\n  align-items: center;\n  display: flex;\n}\n\n.pathlookup-checks__badge--pass {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n  background-color: var(--severity-color-0);\n}\n\n.pathlookup-checks__badge--fail {\n  background-color: var(--severity-color-30);\n}\n\n.pathlookup-checks__label {\n  padding-bottom: var(--base-sizes-1);\n}\n\n.pathlookup-checks__label--main {\n  font-size: .875rem;\n  line-height: 1.25rem;\n  font-weight: var(--base-font-weight-semibold);\n}\n\n.pathlookup-checks__label--minor {\n  font-size: .75rem;\n  line-height: 1rem;\n  font-weight: var(--base-font-weight-bold);\n}\n\n.pathlookup-checks__data {\n  font-size: .75rem;\n  line-height: 1rem;\n}\n\n.pathlookup-checks__data--error {\n  color: #de392c;\n}\n\n.severity-counts-list-item--intents {\n  border-left: 3px solid #0000;\n  padding-right: 30px;\n  font-size: 13px;\n}\n\n.severity-counts-list-item--collabsible-label {\n  font-weight: var(--base-font-weight-bold);\n}\n\n.severity-counts-list-item--collabsible-content {\n  padding-left: var(--base-sizes-12);\n}\n\n.accordion__row--collapsed .severity-counts-list-item--intents-selected-within, .severity-counts-list-item--intents-selected {\n  background: var(--lightgray-d);\n  border-left: 3px solid #4f81bd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
